import { getIdFromPath } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { NotAllowed } from "../components/not-allowed";
import { ValidationRulesPage } from "./validation-rules-page";
import { ValidationRulesWizardPage } from "./validation-rules-wizard/validation-rules-wizard-page";

export const ValidationRulesRouter = () => {
    const current = getIdFromPath(3);
    const id = getIdFromPath(4);

    return <>
        {
            !current && Can(UserEntitlementCatalogs.ViewValidationRuleTab) ? <ValidationRulesPage /> :
                current === 'new' && Can(UserEntitlementCatalogs.ViewCreateValidationRuleButton) ? <ValidationRulesWizardPage /> :
                    current === 'edit' && Can(UserEntitlementCatalogs.EditValidationRulePage) && id !== '' ? <ValidationRulesWizardPage id={id} /> :
                        <NotAllowed />
        }
    </>
}
